export const CONFIGURAR_USUARIO = 'configurar-usuario';
export const ESCUCHAR_PREPARAR_JUGO = 'escuchar-preparar-jugo';
export const ESCUCHAR_NUEVO_TICKET = 'escuchar-nuevo-ticket';
export const EMITIR_ESTADO_RITA = 'emitir-estado-rita';
export const ESUCHAR_USUARIO_INCIADO = 'usuario-iniciado';

export const ELIMINAR_USUARIO = 'eliminar-cliente';